/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiateResetPasswordWithTokenCommand
 */
export interface InitiateResetPasswordWithTokenCommand {
    /**
     * 
     * @type {string}
     * @memberof InitiateResetPasswordWithTokenCommand
     */
    emailAddress: string;
}

export function InitiateResetPasswordWithTokenCommandFromJSON(json: any): InitiateResetPasswordWithTokenCommand {
    return InitiateResetPasswordWithTokenCommandFromJSONTyped(json, false);
}

export function InitiateResetPasswordWithTokenCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateResetPasswordWithTokenCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailAddress': json['emailAddress'],
    };
}

export function InitiateResetPasswordWithTokenCommandToJSON(value?: InitiateResetPasswordWithTokenCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emailAddress': value.emailAddress,
    };
}

